/**
 * ChannelCustomDTO entity class
 */

/**
 * ChannelCustomDTOFactory
 * returns ChannelCustomDTO entity class
 *
 * @class ChannelCustomDTOFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.ChannelCustomDTO} class
 *
 * @ngdoc factory
 * @name mwApp.factory:ChannelCustomDTOFactory
 */
/* @ngInject */
export default function ChannelCustomDTOFactory (ChannelDTO) {
  /* === ChannelCustomDTO class === */

  /**
   * ChannelCustomDTO model
   *
   * @class ChannelCustomDTO
   * @classdesc ChannelCustomDTO model
   * @memberof models
   * @see models
   * @extends models.ChannelDTO
   * @param {Object} [object] - initial object, containing ChannelCustomDTO entity fields
   * @return {models.ChannelCustomDTO} ChannelCustomDTO entity
   */
  function ChannelCustomDTO () {
    var obj = ChannelDTO.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  ChannelCustomDTO.prototype = Object.create(ChannelDTO.prototype)
  ChannelCustomDTO.prototype.constructor = ChannelCustomDTO

  /* === ChannelCustomDTO instance methods & fields === */

  Object.assign(ChannelCustomDTO.prototype, {

    /**
     * url template
     *
     * @memberof models.ChannelCustomDTO#
     * @type {String}
     */
    _urlTemplate: 'api/subscribers/{{::subscriber.id}}/channels/{{::id}}',

    /**
     * public url template,
     *
     * @memberof models.ChannelCustomDTO#
     * @type {String}
     */
    _publicUrlTemplate: 'subscribers/{{::subscriber.id}}/customstreams/' +
                        '{{::id ? channelType.toLowerCase() + "/" : "#" + channelType.toLowerCase()}}{{::id}}'

  })

  /* === ChannelCustomDTO static methods & fields === */

  // copy all static methods from ChannelDTO class
  Object.assign(ChannelCustomDTO, ChannelDTO)
  ChannelCustomDTO._name = 'ChannelCustomDTO'
  ChannelCustomDTO._publicName = 'Custom Channel'
  ChannelCustomDTO.init()

  // permissions
  ChannelCustomDTO.access = {
    view: 'viewSubscriberCustomStream viewChannel | createCatchup | editCatchup | editNetwork | editCategory |',
    create: 'createSubscriberCustomStream',
    edit: 'editSubscriberCustomStream',
    delete: 'deleteSubscriberCustomStream'
  }

  return ChannelCustomDTO
}
